import React from 'react';

function LostBirdPrivacyPolicy() {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 24px',
      color: '#e2e8f0',
      fontFamily: 'system-ui, sans-serif',
      lineHeight: '1.7',
    }}>
      <h1 style={{ fontSize: '1.8rem', marginBottom: '4px', color: '#f8fafc' }}>Privacy Policy — Lost Bird</h1>
      <p style={{ color: '#94a3b8', marginBottom: '32px', fontSize: '0.9rem' }}>Last updated: June 19, 2026</p>

      <p>
        This Privacy Policy describes how Lost Bird ("the game", "we", "us") handles information when you play on Android devices.
      </p>

      <hr style={{ border: 'none', borderTop: '1px solid #334155', margin: '28px 0' }} />

      <h2 style={h2}>1. Information We Collect</h2>

      <h3 style={h3}>Information you provide:</h3>
      <ul style={ul}>
        <li>If you sign in with Google, we receive your Google display name and email address.</li>
        <li>If you play as a guest, no personal account information is collected.</li>
      </ul>

      <h3 style={h3}>Information collected automatically:</h3>
      <ul style={ul}>
        <li>Game progress: levels completed, star ratings, scores, and coin totals.</li>
        <li>A randomly assigned anonymous user ID (generated by Firebase if you play as a guest).</li>
        <li>Your high score submitted to the global leaderboard.</li>
      </ul>

      <h3 style={h3}>Information we do NOT collect:</h3>
      <ul style={ul}>
        <li>We do not collect your real name, phone number, location, contacts, or payment information.</li>
        <li>We do not collect or access photos, camera, or microphone.</li>
      </ul>

      <hr style={{ border: 'none', borderTop: '1px solid #334155', margin: '28px 0' }} />

      <h2 style={h2}>2. How We Use Your Information</h2>
      <p>We use the information collected solely to:</p>
      <ul style={ul}>
        <li>Save and restore your game progress across sessions.</li>
        <li>Display your score on the global leaderboard.</li>
        <li>Show rewarded video advertisements (to earn in-game revives).</li>
        <li>Send optional push notifications (daily reminders to play, if you have not disabled them in your device settings).</li>
      </ul>

      <hr style={{ border: 'none', borderTop: '1px solid #334155', margin: '28px 0' }} />

      <h2 style={h2}>3. Third-Party Services</h2>
      <p>The game uses the following third-party services, each governed by their own privacy policy:</p>

      <div style={{ overflowX: 'auto', marginTop: '16px' }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '0.9rem',
        }}>
          <thead>
            <tr style={{ background: '#1e293b' }}>
              <th style={th}>Service</th>
              <th style={th}>Purpose</th>
              <th style={th}>Privacy Policy</th>
            </tr>
          </thead>
          <tbody>
            {[
              ['Google Firebase', 'Authentication, cloud saves, leaderboard', 'policies.google.com/privacy'],
              ['Google Play Games Services', 'Leaderboard scores', 'policies.google.com/privacy'],
              ['Google AdMob', 'Rewarded video ads', 'policies.google.com/privacy'],
            ].map(([service, purpose, policy], i) => (
              <tr key={i} style={{ background: i % 2 === 0 ? '#0f172a' : '#1e293b' }}>
                <td style={td}>{service}</td>
                <td style={td}>{purpose}</td>
                <td style={td}>
                  <a href={`https://${policy}`} target="_blank" rel="noopener noreferrer"
                    style={{ color: '#60a5fa' }}>{policy}</a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '10px' }}>
        These services may collect device identifiers and usage data in accordance with their own policies.
      </p>

      <hr style={{ border: 'none', borderTop: '1px solid #334155', margin: '28px 0' }} />

      <h2 style={h2}>4. Data Storage and Retention</h2>
      <ul style={ul}>
        <li>Game progress (coins, levels, streak) is stored locally on your device.</li>
        <li>If you are signed in, scores and progress are also stored in Google Firebase's secure cloud servers.</li>
        <li>You may request deletion of your cloud data at any time by contacting us at the email below. Local data can be deleted by uninstalling the game.</li>
      </ul>

      <hr style={{ border: 'none', borderTop: '1px solid #334155', margin: '28px 0' }} />

      <h2 style={h2}>5. Children's Privacy</h2>
      <p>
        Lost Bird is rated for general audiences. We do not knowingly collect personal information from children under 13.
        If you are a parent or guardian and believe your child has provided personal information, please contact us and we will delete it promptly.
      </p>

      <hr style={{ border: 'none', borderTop: '1px solid #334155', margin: '28px 0' }} />

      <h2 style={h2}>6. Data Security</h2>
      <p>
        We use Google Firebase, which employs industry-standard security measures. We do not sell, trade, or otherwise transfer your information to outside parties.
      </p>

      <hr style={{ border: 'none', borderTop: '1px solid #334155', margin: '28px 0' }} />

      <h2 style={h2}>7. Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. We will notify you of any changes by updating the "Last updated" date at the top.
        Continued use of the game after changes constitutes your acceptance of the updated policy.
      </p>

      <hr style={{ border: 'none', borderTop: '1px solid #334155', margin: '28px 0' }} />

      <h2 style={h2}>8. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact:</p>
      <p style={{ marginTop: '8px' }}>
        <strong style={{ color: '#f8fafc' }}>Subham Divakar</strong><br />
        <a href="mailto:shubham.divakar@gmail.com" style={{ color: '#60a5fa' }}>shubham.divakar@gmail.com</a>
      </p>
    </div>
  );
}

const h2 = {
  fontSize: '1.2rem',
  color: '#f1f5f9',
  marginBottom: '12px',
  marginTop: '0',
};

const h3 = {
  fontSize: '1rem',
  color: '#cbd5e1',
  marginBottom: '8px',
  marginTop: '16px',
};

const ul = {
  paddingLeft: '20px',
  marginBottom: '12px',
};

const th = {
  textAlign: 'left',
  padding: '10px 14px',
  color: '#94a3b8',
  borderBottom: '1px solid #334155',
  whiteSpace: 'nowrap',
};

const td = {
  padding: '10px 14px',
  borderBottom: '1px solid #1e293b',
  verticalAlign: 'top',
};

export default LostBirdPrivacyPolicy;
